import { EmptyState } from '@aibi/ui';
import { Shapes } from 'lucide-react';
import type { RendererProps } from '../types';

/** Marcador para tipos del catalogo que aun no tienen renderer registrado. */
export function UnsupportedRenderer({ spec }: RendererProps) {
  return (
    <EmptyState
      icon={<Shapes />}
      title="Visualizacion disponible proximamente"
      description={`El tipo "${spec.type}" esta en el catalogo, pero su renderer aun no se ha registrado. El analisis se conserva: cambie a otro tipo para verlo.`}
    />
  );
}
